import { gql } from 'graphql-request';
import { baseApi } from './baseApi';

export const conceptsApi = baseApi.injectEndpoints({
  endpoints: (builder: any) => ({
    // queries
    getConcepts: builder.query({
      query: () => ({
        body: gql`
          query Query($subsiteShortCode: String!) {
            findConcepts(subsite_short_code: $subsiteShortCode) {
              border_color
              code
              color
              created_at
              id
              name
              updated_at
            }
          }
        `,
        variables: {
          subsiteShortCode: 'dvr',
        },
      }),
      transformResponse: (res: any) => res.findConcepts,
    }),
  }),
  overrideExisting: false,
});

export const { useGetConceptsQuery, useLazyGetConceptsQuery } = conceptsApi;
